import FooterC1Links from '../FooterC1Links';
import FooterC1Share from '../FooterC1Share';
import Link from '@/components/utils/Link';
import './index.scss';
import { useLang } from '@/i18n';

export default function FooterC1({ locale, theme = 'black', footerConfig }: { locale: string; theme: 'white' | 'black' | 'gray'; footerConfig: any }) {
    const { t } = useLang('shared');
    const textList = footerConfig?.LEFT_TERMS || [];
    const iconList = footerConfig?.RIGHT_SOCIAL_ICON || [];
    return (
        <div className={`footer-FooterC1 footer-FooterC1-theme-${theme}`}>
            <FooterC1Links locale={locale} list={textList} theme={theme} />
            <div className="footer-FooterC1-shares">
                <p className="footer-FooterC1-copywrite">
                    {t('bottom_subscription.site_bottom_copyrightV2', {
                        nowYear: new Date().getFullYear(),
                    }) ||
                        t('bottom_subscription.site_bottom_copyright', {
                            nowYear: new Date().getFullYear(),
                        })}
                    {locale === 'cn' && (
                        <Link
                            href={'https://beian.miit.gov.cn/#/Integrated/index'}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'bottom_navigation',
                                navigation_name: '备案号',
                            }}
                        >
                            粤ICP备2020097871号
                        </Link>
                    )}
                </p>
                <FooterC1Share list={iconList} />
            </div>
        </div>
    );
}
